import { render, staticRenderFns } from "./SortListItem.vue?vue&type=template&id=524ffe40&scoped=true"
import script from "./SortListItem.vue?vue&type=script&lang=js"
export * from "./SortListItem.vue?vue&type=script&lang=js"
import style0 from "./SortListItem.vue?vue&type=style&index=0&id=524ffe40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524ffe40",
  null
  
)

export default component.exports